import { Injectable } from '@angular/core'
import { Subject } from 'rxjs'
import { ThemeConfig } from '../models/app-theme.model'
@Injectable()
export class ThemeService {
  constructor() {}

  config: ThemeConfig = {
    theme: 'bootstrap4-light-blue',
    dark: false,
  }

  private _themeUpdated = new Subject<ThemeConfig>()
  themeUpdated$ = this._themeUpdated.asObservable()

  private setThemeInLocalStorage() {
    localStorage.setItem('saved-theme', JSON.stringify(this.config))
  }
  private applyThemeFileByName() {
    let themeElement = document.getElementById('theme-css')
    themeElement?.setAttribute('href', 'assets/theme/' + this.config.theme + '/theme.css')
  }
  private applyFontSize() {
    document.documentElement.style.fontSize = `${this.config.fontSize}px`
  }

  private updateTheme() {
    this.setThemeInLocalStorage()
    this.applyThemeFileByName()
    this.applyFontSize()
    this._themeUpdated.next(this.config)
  }

  public initialize() {
    if (localStorage.getItem('saved-theme')) {
      this.config = JSON.parse(localStorage.getItem('saved-theme') as string)
      this.updateTheme()
    }
  }

  public getTheme() {
    return this.config
  }

  public setTheme(themeName: string, isDark: boolean) {
    this.config.dark = isDark
    this.config.theme = themeName

    this.updateTheme()
  }

  public setFontSize(fontSize: number) {
    this.config.fontSize = fontSize
    this._themeUpdated.next(this.config)

    this.updateTheme()
  }
}
